import React, { useState } from 'react';

import Button from '@atlaskit/button/default/button';
import { DynamicTableStateless } from '@atlaskit/dynamic-table';

import { head, rows } from './content/sample-data';

const LoadingPartialPageExample = (): React.JSX.Element => {
	const [isLoading, setIsLoading] = useState(false);
	return (
		<div>
			<Button onClick={() => setIsLoading((loading) => !loading)}>Toggle loading</Button>
			<DynamicTableStateless
				head={head}
				rows={rows}
				rowsPerPage={5}
				page={1}
				isLoading={isLoading}
			/>
		</div>
	);
};

export default LoadingPartialPageExample;
